import { useHttp } from '@/shared/lib'
import { computed, type Ref } from 'vue'
import { useQuery } from '@tanstack/vue-query'

export const useLoadSchedule = (scheduleId: Ref<number | string>) => {
  const http = useHttp()

  const url = computed(() => {
    return `/schedules/${scheduleId.value}`
  })

  const queryKey = computed(() => ['schedules', scheduleId])

  return useQuery({
    queryKey,
    queryFn: () => http.get(url.value),
    retry: false,
  })
}

export const useLoadShortSchedule = (scheduleId: Ref<number | string>) => {
  const http = useHttp()

  const url = computed(() => {
    return `/schedules/${scheduleId.value}`
  })

  const queryKey = computed(() => ['schedules_short', scheduleId])

  return useQuery({
    queryKey,
    queryFn: () => http.get(url.value),
    retry: false,
    enabled: false,
  })
}
